import { DrawerUrlOptions } from "../../../store/drawers";

export interface MItemProps {
  // TODO add type name
  to?: string | { url: string; name?: string; method?: string } | { name: string };
  permission?: string | true | "true" | { url: string; method?: string };

  toModal?: string | DrawerUrlOptions | object | false;
  toSlideover?: string | DrawerUrlOptions | object | false;

  disable?: boolean;
  disabled?: boolean;

  click?: (...args: any[]) => PromiseLike<any> | void;
  onClick?: (...args: any[]) => PromiseLike<any> | void;

  /** Explicitly opt a row out of clickable styling/affordances. */
  noClickable?: boolean;
  /** Mirrors Quasar's q-item `clickable` — accepted for call-site parity; rows are clickable by default (opt out with noClickable). */
  clickable?: boolean;
  /** Compact row spacing (Quasar q-item `dense`). */
  dense?: boolean;
  /** Keyboard/roving focus highlight (Quasar q-item `focused`). */
  focused?: boolean;
  /** Active/selected highlight (Quasar q-item `active`). */
  active?: boolean;

  disabledTooltip?: string;
}

export const mItemDefaults = {
  disabledTooltip: undefined,
} satisfies Partial<MItemProps>;
